package com.wintermar.inspection.util.global_navigation

sealed class NavigationEvent {
    object Logout : NavigationEvent()
}
